import { DEFAULT_AVATAR } from 'config/_const';
import React, { useState } from 'react';
import "./style.scss"

const CircleAvatar = ({ avatarSrc }: { avatarSrc: string }) => {
    const [imgSrc, setImgSrc] = useState(avatarSrc);

    const handleImgError = () => {
        setImgSrc(DEFAULT_AVATAR);
    };

    return (
        <img
            loading="lazy"
            className="bottom-profile-icon"
            src={imgSrc}
            alt="Avatar"
            onError={handleImgError}
        />
    );
};

export default CircleAvatar;
